import { type AxiosInstance } from "axios";
import useAxiosAuth from "../hooks/useAxiosAuth.ts";
import { useQuery } from "@tanstack/react-query";

const fetchSiteGeometryGeoJSON = async (
  axiosAuth: AxiosInstance,
  geometryId: number | string
) => {
  const id =
    typeof geometryId === "string"
      ? geometryId.replace(/\D/g, "") || geometryId
      : geometryId;
  const response = await axiosAuth.get(
    `${process.env.REACT_APP_API_BASE_URL}site_geometry/${id}/get_geojson/`
  );
  return response.data;
};

// Fetches site geometry as GeoJSON from the get_geojson endpoint.

export function useSiteGeometryGeoJSON(session: any, geometryId: number | string | undefined) {
  const axiosAuth = useAxiosAuth();
  return useQuery({
    queryKey: ["site_geometry_geojson", geometryId],
    queryFn: () => fetchSiteGeometryGeoJSON(axiosAuth, geometryId as number | string),
    select: (data) => (data && typeof data === "object" ? data : null),
    enabled: !!session?.user && geometryId != null && geometryId !== "",
    refetchOnWindowFocus: false,
  });
}
